(() => {
  if (window.shylexGiftDrawerBound) return;
  window.shylexGiftDrawerBound = true;
  let lastAdd = 0;
  let changingGift = false;
  const selector = '#CartDrawer.shylex-cart [data-shylex-gift-variant]';
  const root = window.Shopify?.routes?.root || '/';
  const requestCart = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error('Gift update failed');
    return result;
  };
  const propertiesKey = (properties) => JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
  const findVariant = (cart, variant, original) => cart.items.find((item) =>
    String(item.variant_id) === String(variant) &&
    propertiesKey(item.properties) === propertiesKey(original.properties) &&
    (item.selling_plan_allocation?.selling_plan?.id || null) === (original.selling_plan_allocation?.selling_plan?.id || null)
  );
  const addGift = (id, quantity, original) => requestCart('cart/add.js', {
    items: [{ id: Number(id), quantity, properties: original.properties || {},
      ...(original.selling_plan_allocation ? { selling_plan: original.selling_plan_allocation.selling_plan.id } : {}) }]
  });
  const bundledSections = (drawer) => {
    const sections = [drawer.dataset.sectionId];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return [...new Set(sections)].slice(0, 5);
  };
  const renderCart = async (cart, sections, variant, original) => {
    if (!cart.sections || !cart.sections[document.getElementById('CartDrawer').dataset.sectionId]) {
      const response = await fetch(`${root}?sections=${encodeURIComponent(sections.join(','))}`, { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart refresh failed');
      cart.sections = await response.json();
    }
    const line = original ? findVariant(cart, variant, original) : null;
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
      source: 'shylex-gift-variant', cart, line: line?.key, name: 'shylex_gift_variant'
    });
  };
  const changeGift = async (select) => {
    const nextVariant = select.value;
    if (changingGift || nextVariant === select.dataset.currentVariant) return;
    changingGift = true;
    const drawer = select.closest('cart-drawer');
    const controls = [...drawer.querySelectorAll('cart-items button, cart-items input, cart-items select')].map((element) => [element, element.disabled]);
    controls.forEach(([element]) => { element.disabled = true; });
    drawer.setAttribute('aria-busy', 'true');
    const sections = bundledSections(drawer);
    const sectionBody = { sections, sections_url: window.location.pathname };
    const productId = select.dataset.productId;
    const errorMessage = select.dataset.errorMessage;
    let original;
    let previousTargetQuantity = 0;
    let added = false;
    let failed = false;
    try {
      const before = await requestCart('cart.js');
      original = before.items.find((item) => item.key === select.dataset.lineKey);
      if (!original || original.final_line_price !== 0 || String(original.product_id) !== productId) throw new Error('Gift line changed');
      previousTargetQuantity = findVariant(before, nextVariant, original)?.quantity || 0;
      await addGift(nextVariant, original.quantity, original);
      added = true;
      let cart = await requestCart('cart.js');
      const oldLine = findVariant(cart, original.variant_id, original);
      if (oldLine) cart = await requestCart('cart/change.js', { id: oldLine.key, quantity: 0, ...sectionBody });
      const gift = findVariant(cart, nextVariant, original);
      if (!gift || gift.quantity !== previousTargetQuantity + original.quantity || gift.final_line_price !== 0 || cart.total_price !== before.total_price) {
        throw new Error('Gift offer changed');
      }
      await renderCart(cart, sections, nextVariant, original);
    } catch (error) {
      failed = true;
      try {
        let cart = await requestCart('cart.js');
        if (added && original) {
          // Restore only this exchange; preserve unrelated cart lines and bundle properties.
          const oldQuantity = findVariant(cart, original.variant_id, original)?.quantity || 0;
          if (oldQuantity < original.quantity) {
            await addGift(original.variant_id, original.quantity - oldQuantity, original);
            cart = await requestCart('cart.js');
          }
          const target = findVariant(cart, nextVariant, original);
          if (target && target.quantity > previousTargetQuantity) {
            cart = await requestCart('cart/change.js', { id: target.key, quantity: previousTargetQuantity, ...sectionBody });
          }
        }
        await renderCart(cart, sections, original?.variant_id, original);
      } catch (refreshError) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      }
    } finally {
      changingGift = false;
      drawer.removeAttribute('aria-busy');
      controls.forEach(([element, disabled]) => { if (element.isConnected) element.disabled = disabled; });
      const current = [...document.querySelectorAll(selector)].find((element) => element.dataset.productId === productId);
      if (current) {
        current.disabled = false;
        current.value = current.dataset.currentVariant;
        const error = document.getElementById(current.getAttribute('aria-describedby'));
        if (error) { error.textContent = failed ? errorMessage : ''; error.hidden = !failed; }
        current.focus({ preventScroll: true });
      }
    }
  };
  // Capture prevents the native quantity handler from interpreting a variant ID as a quantity.
  document.addEventListener('change', (event) => {
    if (!event.target.matches(selector)) return;
    event.stopPropagation();
    if (window.SHYLEXGifts) void window.SHYLEXGifts.runExclusive(() => changeGift(event.target));
    else void changeGift(event.target);
  }, true);
  document.addEventListener('click', (event) => {
    if (changingGift && event.target.closest('#CartDrawer.shylex-cart cart-items')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  const updateStatus = () => {
    const status = document.querySelector('#CartDrawer.shylex-cart .shylex-drawer__status');
    if (status) status.hidden = !lastAdd || Date.now() - lastAdd > 8000;
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('#CartDrawer.shylex-cart .shylex-drawer__continue, #CartDrawer.shylex-cart .shylex-drawer__empty [aria-controls="CartDrawer"]');
    if (button && button.getAttribute('aria-controls') === 'CartDrawer') {
      event.preventDefault();
      document.getElementById('CartDrawer')?.hide();
    }
  });
  document.addEventListener('ajaxProduct:added', () => {
    lastAdd = Date.now();
    updateStatus();
  });
  document.addEventListener('cart:updated', updateStatus);
  document.addEventListener('drawer:afterShow', updateStatus);
  document.addEventListener('drawer:afterHide', () => {
    lastAdd = 0;
    updateStatus();
  });
})();
